import { VIEWING_DOCUMENTS_STATE } from './RentalPortalViewingProfileDocuments.constants'

export function getViewingDocumentsState({ documents, hasError, isInitiated }) {
  if (hasError) {
    return VIEWING_DOCUMENTS_STATE.error
  }

  if (!isInitiated) {
    return VIEWING_DOCUMENTS_STATE.loading
  }

  return documents?.length > 0
    ? VIEWING_DOCUMENTS_STATE.table
    : VIEWING_DOCUMENTS_STATE.empty
}

export function getIsViewingDocumentsEmpty(state) {
  return state === VIEWING_DOCUMENTS_STATE.empty
}

export function getIsViewingDocumentsError(state) {
  return state === VIEWING_DOCUMENTS_STATE.error
}
